import onResize from '../helpers/on-resize';
import transitionEnd from '../helpers/transition-end';
import { viewport } from '../helpers/variables';
import { $ } from '../helpers/query-selector';

const langList = $('.js-lang-list');
const langToggle = $('.js-nav-lang-toggle');

const langListActiveClass = 'c-nav-meta__lang-list--active';
const langListAnimClass = 'c-nav-meta__lang-list--anim';
let langVisible = false;

function showLang() {
  langVisible = true;

  langToggle.setAttribute('aria-expanded', 'true');

  langList.classList.add(langListActiveClass);
  langList.classList.add(langListAnimClass);
}

async function hideLang() {
  langVisible = false;

  langToggle.setAttribute('aria-expanded', 'false');

  langList.classList.remove(langListActiveClass);
  await transitionEnd(langList, 'opacity');
  langList.classList.remove(langListAnimClass);
}

function init() {
  if (!langList) return;

  langToggle.addEventListener('click', e => {
    langVisible ? hideLang() : showLang();
  });

  // Close if link is clicked
  langList.addEventListener('click', e => {
    if (langVisible && e.target.tagName === 'A') hideLang();
  });

  // Close nav on resize
  onResize(
    () => {
      if (!langVisible || !viewport.l.matches) return;

      hideLang();
    },
    { horizontalOnly: true }
  );
}

export default init;
